module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_17_3.0063ad0b.jpeg";